<template>
    <website-page>
        <div class="top-section gradient-primary">
            <div class="mx-auto col-md-5 my-2 text-center">
                <h4 class="text-white mb-0">
                    {{title|tr}}
                </h4>
            </div>
        </div>
        <div class="page">
            <b-container>
                <e-terms-and-policies :key="$route.path" source="eye-in-website" :type="$route.params.type" :title.sync="title"/>
            </b-container>
        </div>
    </website-page>
</template>

<script>
    import ETermsAndPolicies from "../../vue-components/components/e-terms-and-policies.vue";
    export default {
        name: `terms-and-policies`,
        components: {ETermsAndPolicies},
        data() {
            return {
                title: null
            }
        }
    }
</script>

<style lang="scss" scoped>
    .top-section {
        background-color: #000;
        color: white;
        //background-image: url('../assets/img/poster.jpg');
        background-size: cover;
        padding: 40px;
    }

    .page {
        background: transparent;
    }

    .container {
        max-width: 900px;
    }

    @media(max-width: 600px) {
        .container {
            padding: 5px;
        }
    }
</style>
